/**
 * @see Modified from https://gist.github.com/AlexEscalante/251032be95767366742fce75bdfa269b#file-reactselectwithalloption-js
 */
import PropTypes from 'prop-types';

import React from 'react';
import { default as ReactSelect } from 'react-select';

// specify props.allowSelectAll = true to enable!
const Select = props => {
  if (props.allowSelectAll) {
    const disableOptions =
      props.value &&
      props.value.length === 1 &&
      props.value[0] === props.allOption.value;
    props.options.map(option => {
      option.disabled = disableOptions;
    });

    return (
      <ReactSelect
        {...props}
        options={[props.allOption, ...props.options]}
        onChange={selected => {
          if (
            selected.length > 0 &&
            selected[selected.length - 1].value === props.allOption.value
          ) {
            return props.onChange([props.allOption]);
          }
          return props.onChange(selected);
        }}
      />
    );
  }

  return <ReactSelect {...props} />;
};

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
  }),
};

Select.defaultProps = {
  allOption: {
    label: 'Select all',
    value: '*',
  },
};

export default Select;
